import { createFileRoute, Link } from "@tanstack/react-router";
import { LimitedAuthorizationBody, LEGAL_VERSIONS } from "@/lib/legal/documents";

export const Route = createFileRoute("/legal/limited-authorization")({
  head: () => ({
    meta: [
      { title: "Limited Authorization — Truck Company Center" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: LimitedAuthorizationPage,
});

function LimitedAuthorizationPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <Link to="/" className="text-xs text-muted-foreground hover:text-foreground">← Inicio</Link>
      <h1 className="mt-3 font-display text-3xl font-semibold text-foreground md:text-4xl">
        Limited Authorization
      </h1>
      <p className="mt-2 text-xs uppercase tracking-[0.18em] text-label-accent">
        Version {LEGAL_VERSIONS.limited_authorization}
      </p>
      <div className="mt-6"><LimitedAuthorizationBody /></div>
    </div>
  );
}
